import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLenis } from "lenis/react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Download from "@/components/Download";
import SignupForms from "@/components/SignupForms";
import About from "@/components/About";

export default function Home() {
  const lenis = useLenis();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => {
        if (lenis) lenis.scrollTo(location.hash, { offset: -72, duration: 1.2 });
        else document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.key, location.hash, lenis]);

  return (
    <main>
      <Hero />
      <Marquee />
      <HowItWorks />
      <Features />
      <Download />
      <SignupForms />
      <About />
    </main>
  );
}
